// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAqQf6OUCWKCanVuVuS5Rw7qnQE60hVq98",
  authDomain: "score-board-host.firebaseapp.com",
  projectId: "score-board-host",
  storageBucket: "score-board-host.appspot.com",
  messagingSenderId: "590689795820",
  appId: "1:590689795820:web:ef69b4d71104080d582fc9",
  measurementId: "G-RMPNS4RDTL",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
